// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

import React from 'react';

import Chat from './chat/Chat';

function App() {
  return (
    <div className="App full-width full-height">
      <Chat />
    </div>    
  );
}

export default App;
